/* eslint-disable react/no-array-index-key */
import React, {
  ChangeEvent,
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from 'react';

import { Tags } from '../../MyComponents/Tags';
import { InputTagSt } from '../../styles';
import {
  FilterContainer,
  FilterHeader,
  FilterTitle,
  FilterTitleRow,
  FilterRow,
  DropdownContainer,
  DropdownButton,
  DropdownList,
  DropdownItem,
  InputContainer,
  FieldContainer,
  StyledInput,
  FullWidthButton,
} from './styles';
import Macro from '~/components/Macro';
import { FilterContext } from '~/context/filter';
import { useFiltro } from '../../FiltroContext';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { EnterLabel } from '../../MyComponents/Tags/styles';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const options = [
  {
    description: 'Igual à',
    cod_condicao: 0,
  },
  {
    description: 'Maior ou igual à',
    cod_condicao: 1,
  },
  {
    description: 'Menor ou igual à',
    cod_condicao: 2,
  },
  {
    description: 'Diferente de',
    cod_condicao: 3,
  },
  {
    description: 'Entre',
    cod_condicao: 6,
  },
  {
    description: 'Preenchido',
    cod_condicao: 7,
  },
  {
    description: 'Não Preenchido',
    cod_condicao: 8,
  },
];

const optionsLookup = [
  {
    description: 'Igual à',
    cod_condicao: 0,
  },
  {
    description: 'Diferente de',
    cod_condicao: 3,
  },
  {
    description: 'Preenchido',
    cod_condicao: 7,
  },
  {
    description: 'Não Preenchido',
    cod_condicao: 8,
  },
];

const TypeInteger: React.FC = () => {
  // Condições
  const igualA = 0;
  const diferenteDe = 3;
  const entre = 6;
  const preenchido = 7;
  const naoPreenchido = 8;

  const [isMulti, setMulti] = useState<boolean>(false);
  const [isInfo, setInfo] = useState<boolean>(false);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { RemoveFilterEmptyByIndex } = useContext(FilterContext);
  const { handleSetNewValue, isFilterBlock, filter, removeFilter } =
    useFiltro();

  const [value, setValue] = useState<any>(
    Array.isArray(filter.des_valor) ? filter.des_valor[0] : filter.des_valor,
  );
  const [value2, setValue2] = useState<number>(
    Array.isArray(filter.des_valor) ? filter.des_valor[1] : filter.des_valor,
  );
  const [tags, setTags] = useState<string[]>(
    Array.isArray(filter.des_valor) ? filter.des_valor : [],
  );
  const [condition, setCondition] = useState(filter.condicao);

  useEffect(() => {
    if (condition === entre) {
      setMulti(true);
    } else {
      setMulti(false);
    }
  }, [condition]);

  useEffect(() => {
    if (filter.cod_tipo_info > 0) {
      setInfo(true);
    }
  }, [filter.cod_tipo_info]);

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleChangeCondition = (newCondition: number) => {
    setCondition(newCondition);
    setDropdownOpen(false);
  };

  const getConditionText = (condCode: number) => {
    const option = isInfo
      ? optionsLookup.find((opt) => opt.cod_condicao === condCode)
      : options.find((opt) => opt.cod_condicao === condCode);
    return option ? option.description : 'Selecione';
  };

  const ValidateInputs = useCallback(() => {
    if (condition === naoPreenchido || condition === preenchido) {
      return false;
    }
    if (filter.cod_tipo_info > 0) {
      return value === undefined;
    }
    if (condition === igualA || condition === diferenteDe) {
      if (tags.length < 1) {
        return true;
      }
    } else if (
      !(condition === entre ? value >= 0 && value2 >= 0 : value >= 0)
    ) {
      return true;
    }
    return false;
  }, [
    condition,
    naoPreenchido,
    preenchido,
    filter.cod_tipo_info,
    value,
    igualA,
    diferenteDe,
    tags.length,
    entre,
    value2,
  ]);

  const handleDesValor = useCallback(() => {
    type ConditionMappings = {
      [key: number]: undefined | string[] | number[];
    };

    const conditionMappings: ConditionMappings = {
      [preenchido]: undefined,
      [naoPreenchido]: undefined,
      [igualA]: tags,
      [diferenteDe]: tags,
      [entre]: [value, value2],
    };

    if (filter.cod_tipo_info > 0) {
      return value;
    }

    return conditionMappings[condition] || value;
  }, [
    preenchido,
    naoPreenchido,
    igualA,
    tags,
    diferenteDe,
    entre,
    value,
    value2,
    filter.cod_tipo_info,
    condition,
  ]);

  const handleSetValueFiltro = useCallback(() => {
    if (ValidateInputs()) {
      if (!isFilterBlock) RemoveFilterEmptyByIndex(filter.index);
      return;
    }
    const Value = handleDesValor();
    handleSetNewValue({
      index: filter.index,
      des_nome: filter.des_nome,
      nome_bd: filter.nome_bd,
      condicao: condition,
      des_valor: Value,
      cod_tipo_dados: filter.cod_tipo_dados,
      cod_tipo_info: filter.cod_tipo_info,
      cod_campo: filter.cod_campo,
      isBlock: isFilterBlock,
      expressao_validacao: filter.expressao_validacao,
      listagem_info: filter.listagem_info,
      tipo_expressao: filter.tipo_expressao,
    });
  }, [
    ValidateInputs,
    isFilterBlock,
    RemoveFilterEmptyByIndex,
    filter.index,
    handleDesValor,
    handleSetNewValue,
    filter.des_nome,
    filter.nome_bd,
    condition,
    filter.cod_tipo_dados,
    filter.cod_tipo_info,
    filter.cod_campo,
    filter.expressao_validacao,
    filter.listagem_info,
    filter.tipo_expressao,
  ]);

  // Removido o useEffect que executava automaticamente ao digitar
  // Agora a busca só acontece quando o usuário clica em "Atualizar"

  const handleTags = (newTags: any) => {
    setTags(newTags);
  };

  const availableOptions = isInfo ? optionsLookup : options;

  return (
    <FilterContainer>
      {/* Header com título, dropdown e botão de remover */}
      <FilterHeader>
        <FilterTitleRow>
          <FilterTitle>{filter.des_nome}</FilterTitle>
          <DropdownContainer ref={dropdownRef}>
            <DropdownButton
              isOpen={dropdownOpen}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {getConditionText(condition)}
              {dropdownOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </DropdownButton>
            {dropdownOpen && (
              <DropdownList>
                {availableOptions.map((opt) => (
                  <DropdownItem
                    key={opt.cod_condicao}
                    isSelected={condition === opt.cod_condicao}
                    onClick={() => handleChangeCondition(opt.cod_condicao)}
                  >
                    {opt.description}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </DropdownContainer>
        </FilterTitleRow>
      </FilterHeader>

      {/* Linha dos Inputs de Valor */}
      {condition !== naoPreenchido && condition !== preenchido && (
        <FilterRow>
          <InputContainer>
            {!isInfo ? (
              <>
                {(condition === igualA || condition === diferenteDe) && (
                  <FieldContainer>
                    <EnterLabel>
                      Pressione <kbd>Enter</kbd> para <strong>Confirmar</strong>
                    </EnterLabel>
                    <InputTagSt style={{ width: '100%' }}>
                      <Tags
                        tags={tags}
                        onChange={(e: any) => {
                          setValue('');
                          handleTags(e);
                        }}
                        inputProps={{
                          type: 'number',
                          maxLength: 2147483647,
                        }}
                      />
                    </InputTagSt>
                  </FieldContainer>
                )}

                {condition !== igualA && condition !== diferenteDe && (
                  <StyledInput
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      setTags([]);

                      if (
                        Number(e.target.value) > 2147483647 ||
                        Number(e.target.value) < -2147483647
                      ) {
                        return;
                      }
                      setValue(parseInt(e.target.value, 10));
                    }}
                    id={filter.index}
                    value={value}
                    type="number"
                    step="1"
                    min={0}
                    placeholder="Digite o valor..."
                  />
                )}
              </>
            ) : (
              <div style={{ flex: 1, width: '100%' }}>
                <Macro
                  tipoInfo={filter.cod_tipo_info}
                  defaultValue={value}
                  onChange={(e) => {
                    setTags([]);
                    setValue(e.value);
                  }}
                />
              </div>
            )}

            {/* Segunda entrada para condição "Entre" */}
            {isMulti && (
              <>
                <span>e</span>
                {!isInfo ? (
                  <StyledInput
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      if (
                        Number(e.target.value) > 2147483647 ||
                        Number(e.target.value) < -2147483647
                      ) {
                        return;
                      }
                      setValue2(parseInt(e.target.value, 10));
                    }}
                    value={value2}
                    type="number"
                    step="1"
                    min={0}
                    placeholder="Digite o valor..."
                  />
                ) : (
                  <div style={{ flex: 1, width: '100%' }}>
                    <Macro
                      tipoInfo={filter.cod_tipo_info}
                      defaultValue={value2}
                      onChange={(e) => {
                        setValue2(e.value);
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </InputContainer>
        </FilterRow>
      )}

      {/* Botão de Atualizar */}
      <FullWidthButton>
        <CustomButtonNovo
          style={{ backgroundColor: ValidateInputs() ? '#dcdfe0' : '#0052CC' }}
          type="button"
          onClick={handleSetValueFiltro}
          disabled={ValidateInputs()}
          label="Atualizar"
        />
      </FullWidthButton>
    </FilterContainer>
  );
};

export default TypeInteger;
